import { createSelector } from 'reselect';

const key = 'navigation';

const domains = {
    navigationIsOpen: (state) => state.global[key].navigationIsOpen,
};

const selectorNavigationIsOpen = createSelector(
    [domains.navigationIsOpen],
    (navigationIsOpen) => navigationIsOpen
);

const makeSelectNavigationUsOpen = () => selectorNavigationIsOpen;

export { makeSelectNavigationUsOpen };
